import MyShop from '@components/LocalMerchant/MyShop'
import Grade from '@components/LocalMerchant/MyShop/Grade'
import Regular from '@components/LocalMerchant/MyShop/Regular'
import Package from '@components/LocalMerchant/MyShop/Package'
import Case from '@components/LocalMerchant/MyShop/Case'
import Dynamic from '@components/LocalMerchant/MyShop/Dynamic'
import Full from '@components/LocalMerchant/MyShop/Full'
import Order from '@components/LocalMerchant/MyShop/Order'
import Arrive from '@components/LocalMerchant/MyShop/Arrive'
import Illegal from '@components/LocalMerchant/MyShop/Illegal'
import Droit from '@components/LocalMerchant/MyShop/Droit'

export default {
  path: 'myShop',
  component: MyShop,
  indexRoute: {
    component: Grade
  },
  stat: '我的店铺/首页',
  childRoutes: [
    {
      path: 'regular',
      component: Regular,
      stat: '我的店铺/等级规则'
    },
    {
      path: 'package',
      component: Package,
      stat: '我的店铺/套餐'
    },
    {
      path: 'case',
      component: Case,
      stat: '我的店铺/案例'
    },
    {
      path: 'dynamic',
      component: Dynamic,
      stat: '我的店铺/动态'
    },
    {
      path: 'full',
      component: Full,
      stat: '我的店铺/全款礼'
    },
    {
      path: 'order',
      component: Order,
      stat: '我的店铺/订单礼'
    },
    {
      path: 'arrive',
      component: Arrive,
      stat: '我的店铺/到店礼'
    },
    {
      path: 'illegal',
      component: Illegal,
      stat: '我的店铺/违规记录'
    },
    {
      path: 'droit',
      component: Droit,
      stat: '我的店铺/等级规则'
    }
  ]
}
